<bl-tab-container
  #blTabContainer
  [items]="tabOptions"
  [hideNavItem]="_isHideTabNavItem"
  [multiStage]="_multiStage"
  (changeEvent)="onChangeTab($event)"
  (clickTabEvent)="onClickTab($event)"
  class="tab-main"
>
  <div class="nav-tabs-accordion-content" *ngIf="showAccordionContentFlg">
    <button type="button" class="btn btn-default" (click)="onClickNavTabsExpand()">
      <span [ngClass]="{ 'icon-icon_sort_forward': !_isHideTabNavItem, 'icon-icon_sort_reverse': _isHideTabNavItem }">
        {{!_isHideTabNavItem ? 'タブの一覧を表示しない' : 'タブの一覧を表示する'}}
      </span>
    </button>
  </div>
  <ng-container *ngFor="let tabItem of tabOptions">
    <div
      class="tab-pane with-accordion-content"
      [id]="tabItem.elementId"
      [blTabContainer]="blTabContainer"
    >
      <ng-container>
        <div class="l-contents">
          <div class="p-menu__contents">
            <div class="p-menu__contents--side" *ngIf="!isLoanTab">
              <share-schedule-time-table *ngIf="_isAvailableService[ContractConst.SERVICEID_PRODUCT_PARTSMAN] !== true"
                [organizationCode]="organizationCode"
                [eventIds]="eventIds"
                [shownEditButton]="true"
                [hideReserveBtn]="hideReserveBtn"
                [hideFooter]="hideScheduleFooter"
                [toggleExtension]="_isAvailableBiTool"
                [extensionToggleText]="'今月の実績'"
                [useReserveServiceId]="_useReserveServiceId"
              >
                <div extension>
                  <ng-container *ngIf="_diagnosisResultInfoState === DiagnosisResultInfoState.Reading">
                    <div class="analysis-item">　</div>
                    <div class="analysis-item">　</div>
                  </ng-container>
                  <ng-container *ngIf="_diagnosisResultInfoState === DiagnosisResultInfoState.Success">
                    <div class="analysis-item">
                      <div class="analysis-item__label">入庫台数</div>
                      <div class="analysis-item__value"><span>{{ _diagnosisResultInfo.actualCount | number }}台</span>/{{ _diagnosisResultInfo.goalVcleCnt | number }}台</div>
                    </div>
                    <div class="analysis-item">
                      <div class="analysis-item__label">売上金額</div>
                      <div class="analysis-item__value"><span>{{ _diagnosisResultInfo.actualPriceTotal | actualCurrency: _amountUnit }}</span>/{{ _diagnosisResultInfo.goalPriceTotal | actualCurrency: _amountUnit }}</div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="_diagnosisResultInfoState === DiagnosisResultInfoState.Fail">
                    <div class="analysis-item">データを読み込めませんでした。</div>
                    <div class="analysis-item">　</div>
                  </ng-container>
                  <ng-container *ngIf="_diagnosisResultInfoState === DiagnosisResultInfoState.NoData">
                    <div class="analysis-item">目標を設定すると今月の実績が表示されます。</div>
                    <div class="analysis-item analysis-footer"><button class="btn btn-success" (click)="onClickMokuhyoMngAnalysis()">目標管理</button></div>
                  </ng-container>
                  <div class="analysis-footer">
                    <div shareServiceCheck
                      [serviceId]="ContractConst.SERVICEID_OPT_CMN_SALESTARGET_PROGRESSTOTAL"
                      (changeServiceStateEvent)="onChangeServiceState(ContractConst.SERVICEID_OPT_CMN_SALESTARGET_PROGRESSTOTAL, $event)"
                    >
                      <ng-container *ngIf="_isAvailableService[ContractConst.SERVICEID_OPT_CMN_SALESTARGET_PROGRESSTOTAL] === true; then mngAnalysisResultAvailable; else mngAnalysisResultNotAvailable">
                        {{ _isAvailableService[ContractConst.SERVICEID_OPT_CMN_SALESTARGET_PROGRESSTOTAL] }}
                      </ng-container>
                      <ng-template #mngAnalysisResultAvailable>
                        <button class="btn btn-success" (click)="onClickMngAnalysisResult()">売上目標進捗</button>
                      </ng-template>
                      <ng-template #mngAnalysisResultNotAvailable>
                        <button class="btn btn-add-option" (click)="onClickAppOption(ContractConst.SERVICEID_OPT_CMN_SALESTARGET_PROGRESSTOTAL)">売上目標進捗<span class="icon-icon_lock"></span></button>
                      </ng-template>
                    </div>
                    <div shareServiceCheck
                      [serviceId]="[ContractConst.SERVICEID_OPT_CMN_BI_TOOL]"
                      [condition]="or"
                      (changeServiceStateEvent)="onChangeServiceState(ContractConst.SERVICEID_OPT_CMN_BI_TOOL, $event)"
                    >
                      <ng-container *ngIf="_isAvailableService[ContractConst.SERVICEID_OPT_CMN_BI_TOOL] === true ; then detailAnalysisAvailable; else detailAnalysisNotAvailable">
                        {{ _isAvailableService[ContractConst.SERVICEID_OPT_CMN_BI_TOOL] }}
                      </ng-container>
                      <ng-template #detailAnalysisAvailable>
                        <button class="btn btn-success" (click)="onClickDetailAnalysis()">詳細分析</button>
                      </ng-template>
                      <ng-template #detailAnalysisNotAvailable>
                        <button class="btn btn-add-option" (click)="onClickAppOption(ContractConst.SERVICEID_OPT_CMN_BI_TOOL)">詳細分析<span class="icon-icon_lock"></span></button>
                      </ng-template>
                    </div>

                  </div>
                </div>
              </share-schedule-time-table>
              <share-schedule-time-table *ngIf="_isAvailableService[ContractConst.SERVICEID_PRODUCT_PARTSMAN] === true"
                [organizationCode]="organizationCode"
                [eventIds]="eventIds"
                [shownEditButton]="true"
                [hideReserveBtn]="hideReserveBtn"
                [toggleExtension]="_isAvailableBiToolPm"
                [extensionToggleText]="'今月の実績'"
                [useReserveServiceId]="_useReserveServiceId"
              >
                <div extension>
                  <ng-container *ngIf="_diagnosisResultInfoState === DiagnosisResultInfoState.Fail">
                    <div class="analysis-item">データを読み込めませんでした。</div>
                    <div class="analysis-item">　</div>
                  </ng-container>
                  <ng-container *ngIf="_diagnosisResultInfoState === DiagnosisResultInfoState.NoData">
                    <div class="analysis-item">目標を設定すると今月の実績が表示されます。</div>
                    <div class="analysis-item analysis-footer"><button class="btn btn-success" (click)="onClickMokuhyoMngAnalysis()">目標管理</button></div>
                  </ng-container>
                  <div class="analysis-footer">
                    <div shareServiceCheck
                      [serviceId]="[ContractConst.SERVICEID_OPT_PMC_BI_TOOL_SALESPERFORMANCE, ContractConst.SERVICEID_OPT_PMC_BI_TOOL_STOCKPERFORMANCE]"
                      [condition]="or"
                      (changeServiceStateEvent)="onChangeServiceState(ContractConst.SERVICEID_OPT_PMC_BI_TOOL_SALESPERFORMANCE, $event)"
                    >
                      <ng-container *ngIf="_isAvailableService[ContractConst.SERVICEID_OPT_PMC_BI_TOOL_SALESPERFORMANCE] === true || _isAvailableService[ContractConst.SERVICEID_OPT_PMC_BI_TOOL_STOCKPERFORMANCE] === true; then detailAnalysisAvailable; else detailAnalysisNotAvailable">
                        {{ _isAvailableService[ContractConst.SERVICEID_OPT_PMC_BI_TOOL_SALESPERFORMANCE] || _isAvailableService[ContractConst.SERVICEID_OPT_PMC_BI_TOOL_STOCKPERFORMANCE] }}
                      </ng-container>
                      <ng-template #detailAnalysisAvailable>
                        <button class="btn btn-success" (click)="onClickDetailAnalysis()">詳細分析</button>
                      </ng-template>
                      <ng-template #detailAnalysisNotAvailable>
                        <button class="btn btn-add-option" (click)="onClickAppOption(ContractConst.SERVICEID_OPT_PMC_BI_TOOL_SALESPERFORMANCE)">詳細分析<span class="icon-icon_lock"></span></button>
                      </ng-template>
                    </div>

                  </div>
                </div>
              </share-schedule-time-table>
            </div>
            <div *ngIf="tabItem.tabId !== MaintenanceTabId.IsshinTasuke"
              class="p-menu__contents--main"
              [style.backgroundColor]="_oemBackgroundColor"
              (click)="onBackgroundClick()"
            >
              <ng-container *ngIf="tabItem.menuGroup.businessMenuStatus === BusinessMenuStatus.NotSigned">
                <div class="p-menu__contents--main__option u-fsize-m">
                  <button class="btn btn-add-option" (click)="onClickAppOption(tabItem.menuGroup.serviceId)"
                  >オプション説明・購入はこちら<span class="icon-icon_lock"></span></button>
                </div>
              </ng-container>
              <div class="p-menu__contents--main__note u-fsize-m" *ngIf="!isLoanTab">
                <!-- 暫定的に非表示 -->
                <!-- <span class="note--unread">未案内</span> -->
                <span
                  *ngIf="tabItem.isShowDraftExplanatoryNote"
                  class="note--draft">
                  <ng-container *ngIf="tabItem.isShowBlPayAffiliatedNote; else draftSharedVehicleStock">新規の利用開始申込</ng-container>
                  <ng-template #draftSharedVehicleStock>
                    <ng-container *ngIf="tabItem.isShowSharedVehicleStockNote; else draftDefault">進行中・下書き</ng-container>
                    <ng-template #draftDefault>下書き</ng-template>
                  </ng-template>
                </span>
                <span
                  *ngIf="tabItem.isShowStayExplanatoryNote"
                  class="note--stay">
                  <ng-container *ngIf="tabItem.isShowBlPaySuppliersNote; else staySharedVehicleStock">差し戻された利用開始申込</ng-container>
                  <ng-template #staySharedVehicleStock>
                    <ng-container *ngIf="tabItem.isShowSharedVehicleStockNote; else stayDefault">要対応</ng-container>
                    <ng-template #stayDefault>次工程待ち</ng-template>
                  </ng-template>
                </span>
              </div>
              <div class="p-menu__contents--main__contents">
                <ng-container *ngFor="let menuItem of bizMenuGroup[tabItem.tabId]; let xIndex = index">
                  <div class="p-menu__panels">
                    <ng-container *ngFor="let menu of menuItem.menus; let yIndex = index">
                      <div
                        class="p-menu__panel"
                        [class.p-menu__panel--line-bottom]="menu.lineBottom"
                      >
                        <ng-container *ngIf="menu.businessMenuContentId !== undefined">
                          <ng-container
                            *ngIf="tabItem.menuGroup.businessMenuStatus === BusinessMenuStatus.Available && menu.businessMenuStatus === BusinessMenuStatus.Available"
                          >
                            <button
                              class="btn p-menu__panel--btn"
                              blCustomFocus
                              [enter]="onKeyDownEnter"
                              (click)="onNext(menu)"
                              (focus)="onFocus($event)"
                              (blur)="onBlur()"
                              [class.first-focus]="xIndex === 0 && yIndex === 0"
                            >
                              <span class="p-menu__panel-header">
                                <span>{{menu.businessMenuContentName}}</span>
                              </span>
                              <span class="menu-img" [ngClass]="menu.businessMenuIconCss"></span>
                              <span class="p-menu__panel-footer">
                              <ng-container *ngIf="menu?.count; else textMessage">
                                <ng-container
                                  *ngIf="existBadge[menu.count.key] && !existBadge[menu.count.key][menu.count.value]; else badgeMessage">
                                  <div class="p-menu__panel-footer--text">未登録</div>
                                </ng-container>
                              </ng-container>
                                <ng-template #textMessage>
                                  <div class="p-menu__panel-footer--text">{{menu.businessMenuExpansionMessage}}</div>
                                </ng-template>
                                <ng-template #badgeMessage>
                                  <span class="badge-position">
                                    <span
                                      *ngIf="badge[menu.count.key] && 0 <= badge[menu.count.key][menu.count.value].draft && tabItem.isShowDraftExplanatoryNote && menu.isShowDraftSlipCount"
                                      class="badge-position--item">
                                      <span
                                        class="draft">{{badge[menu.count.key][menu.count.value].draft > 99 ? '99+' : badge[menu.count.key][menu.count.value].draft}}</span>
                                    </span>
                                    <span
                                      *ngIf="badge[menu.count.key] && 0 <= badge[menu.count.key][menu.count.value].final && tabItem.isShowStayExplanatoryNote"
                                      class="badge-position--item">
                                      <span
                                        class="stay">{{badge[menu.count.key][menu.count.value].final > 99 ? '99+' : badge[menu.count.key][menu.count.value].final}}</span>
                                    </span>
                                  </span>
                                </ng-template>
                              </span>
                            </button>
                          </ng-container>
                          <ng-container
                            *ngIf="!(tabItem.menuGroup.businessMenuStatus === BusinessMenuStatus.Available && menu.businessMenuStatus === BusinessMenuStatus.Available)"
                          >
                            <span
                              class="btn p-menu__panel--btn"
                              [ngClass]="{ 'disable bl-focus-ignore': [BusinessMenuStatus.NowPreparing, BusinessMenuStatus.NoAuthority].includes(menu.businessMenuStatus), 'is-not-contracted': menu.businessMenuStatus === BusinessMenuStatus.NotSigned }"
                              [tabindex]="[BusinessMenuStatus.NowPreparing, BusinessMenuStatus.NoAuthority].includes(menu.businessMenuStatus) ? '-1' : ''"
                            >
                              <span
                                *ngIf="!_showPermissionMask"
                                class="overlay"
                                (click)="onClickDisableMenu(menu)"
                                tooltip="{{ menu.businessMenuStatus === BusinessMenuStatus.NowPreparing ? '近日公開予定' : '利用権限がありません' }}"
                                container="body"
                              >
                                <span
                                  class="glyphicon glyphicon-time"
                                  *ngIf="menu.businessMenuStatus === BusinessMenuStatus.NowPreparing"
                                ></span>
                                <span
                                  class="icon-icon_lock"
                                  *ngIf="menu.businessMenuStatus === BusinessMenuStatus.NotSigned"
                                ></span>
                              </span>
                              <span class="p-menu__panel-header">
                                <span>{{menu.businessMenuContentName}}</span>
                              </span>
                              <span class="menu-img" [ngClass]="menu.businessMenuIconCss"></span>
                              <span class="p-menu__panel-footer">
                                <span class="p-menu__panel-footer--text">{{menu.businessMenuExpansionMessage}}</span>
                              </span>
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <div class="p-menu__lines" [ngClass]="isLoanTab ? 'p-menu__lines__lone' : ''">
                    <ng-container *ngFor="let line of menuItem?.lines">
                      <div class="p-menu__line">
                        <div *ngIf="line.bottom" class="p-menu__line--bottom"></div>
                        <div *ngIf="line.left" class="p-menu__line--left"></div>
                        <div *ngIf="line.right" class="p-menu__line--right"
                             [style.right]="line.rightStyle && line.rightStyle.right"
                             [style.width]="line.rightStyle && line.rightStyle.width"
                        ></div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
              <div class="oem-signature" *ngIf="_oemSignature">
                Powered by BroadLeaf
              </div>
            </div>
            <div *ngIf="tabItem.tabId === MaintenanceTabId.IsshinTasuke" class="p-menu__contents--isshin-tasuke">
              <app-isshin-tasuke-menu-view
                [menuData]="_dispIsshinTasukeMenuData"
                (clickMenuEvent)="onClickIsshinTasukeMenu($event)"
                (clickMemoEvent)="onClickIsshinTasukeMemo()"
              ></app-isshin-tasuke-menu-view>
            </div>
            <div class="p-menu__mask" *ngIf="_showPermissionMask"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</bl-tab-container>



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/biz-menu-page.component.html